<template>
  <div>
    <ul id="course" class="course mt-6 px-4 py-6">
      <li>
        <plan-station
          :editable="editable"
          :station="departure"
          :route="routes[0]"
          :routeIndex="0"
          :showDepartureModal="() => showModal('departure')"
          @openMap="openMap" />
      </li>
      <li v-for="route in routes" v-bind:key="route.index">
        <template v-if="sections !== undefined">
          <plan-banner
            :editable="editable"
            :tickets="sections[route.index]" />
        </template>
        <div class="route" :class="editable ? 'pb-6' : 'pb-10'">
          <add-place
            :editable="editable"
            :newPlaceFromFavorite="() => showModal('favorite', { route: route })"
            :newPlaceFromMap="() => newPlaceFromMap(route)"
            :newPlace="() => showModal('place', { route: route })" />
          <route :route="route" :editable="editable" />
          <search-route v-if="route" :route="route" />
          <div v-if="editable" class="plan-route-change pt-2 pr-2 text-right relative">
            <a @click="changeRoute(route.index)" class="plan-route-change-btn">
              <span>{{ $t('tour_change_route_button') }}</span>
            </a>
          </div>
        </div>
        <plan-place
          v-if="destinations[route.index]"
          :routeIndex="route.index + 1"
          :editable="editable"
          :place="destinations[route.index]"
          :route="route"
          :next="routes[route.index + 1]"
          :changeVisit="() => showModal('visit', { destination: destinations[route.index], route: route })"
          :deleteDestination="() => deleteDestination(destinations[route.index])"
          :changeTime="() => showModal('datetime', { destination: destinations[route.index], route: route })"
          @openMap="openMap" />
      </li>
      <li>
        <plan-station
          :isDeparture=false
          :editable="editable"
          :station="arrival"
          :route="routes.slice(-1)[0]"
          :routeIndex="routes.length"
          :showDepartureModal="() => showModal('arrival')"
          @openMap="openMap" />
      </li>
    </ul>
    <plan-modal
      v-if="editable"
      v-show="modal.show"
      :closeModal="() => closeModal()"
      :modals=modals
      :kind=modal.kind
      :target=modal.target />
    <div v-if="showChangeRoute">
      <Change-Route
        :changeRouteIndex="changeRouteIndex"
        @closeChangeRoute="closeChangeRoute" />
    </div>
  </div>
</template>

<script>
import PlanPlace from "../molecules/PlanPlace"
import PlanStation from "../molecules/PlanStation"
import PlanModal from "../molecules/PlanModal"
import Route from "../molecules/Route"
import Departure from "../molecules/Departure"
import Arrival from "../molecules/Arrival"
import Visit from "../molecules/Visit"
import NewPlaceFavorite from "../molecules/NewPlaceFavorite"
import NewPlace from "../molecules/NewPlace"
import AddPlace from "../molecules/AddPlace"
import PlanBanner from "../molecules/PlanBanner"
import ChangeRoute from "../molecules/ChangeRoute"
import Datetime from "../molecules/Datetime"
import SearchRoute from "../molecules/SearchRoute"
import { mapGetters } from 'vuex'

export default {
  components: {
    PlanPlace,
    PlanStation,
    PlanModal,
    Route,
    AddPlace,
    PlanBanner,
    ChangeRoute,
    SearchRoute
  },
  props: {
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data () {
    return {
      places: [],
      modal: {
        show: false,
        kind: 'departure',
        target: undefined
      },
      showChangeRoute: false,
      changeRouteIndex: undefined
    }
  },
  methods: {
    closeModal: function () {
      this.modal.show = false
    },
    showModal: function (kind, target = {}) {
      this.modal.show = true
      this.modal.kind = kind
      this.modal.target = target
    },
    setDeparture: function (station) {
      this.$store.dispatch('destinations/updateDepartureStation', station.Name)
      this.$store.dispatch('destinations/updateDepartureStationCode', station.code)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    setArrival: function (station) {
      this.$store.dispatch('destinations/updateArrivalStation', station.Name)
      this.$store.dispatch('destinations/updateArrivalStationCode', station.code)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    deleteDestination: function (destination) {
      this.$store.dispatch('destinations/deleteDestination', destination)
      this.$store.dispatch('routes/search')
    },
    timeUpdate: function (destination, time) {
      const params = {
        destination: destination,
        visit: time
      }
      this.$store.dispatch('destinations/updateVisit', params)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    datetimeUpdate: function (destination, arrivalTime) {
      const params = {
        destination: destination,
        arrivalTime: arrivalTime
      }
      this.$store.dispatch('destinations/updateDatetime', params)
      this.modal.show = false
      this.$store.dispatch('routes/searchIndex')
    },
    addPlace: function (route, time, place) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('places/fetchPlace', place.id)
        .then((p) => {
          const place = {
            name: p['shop_name'],
            location: {
              latitude: p.latitude,
              longitude: p.longitude
            },
            detail: p['shop_introduction'],
            image: p.image,
            genreIds: ["other"]
          }
          // GoogleAnalytics
          this.$gtag.event("プランにPOI追加", {
            poi_name: place.name
          });
          if (place.genreIds.indexOf('TH6_tag159') != -1) {
            this.$store.dispatch('destinations/spliceDestinationLock', { route: route, visit: time, place: place })
            this.$store.dispatch('destinations/setStay', { route: route})

          } else {
            this.$store.dispatch('destinations/spliceDestination', { route: route, visit: time, place: place })
          }

          this.modal.show = false
          this.$store.dispatch('routes/search')
        })
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
    },
    newPlaceFromMap: function (route) {
      const center  = {
        lat: route.points[0].location.latitude,
        lng: route.points[0].location.longitude
      }
      this.$store.dispatch('map/updateCenter', center)
      const params = {
        name: 'plan',
        route: route
      }
      this.$store.dispatch('map/updateFrom', params)
      this.$emit('openMap', params)
    },
    changeRoute: function (index) {
      this.changeRouteIndex = index
      this.showChangeRoute = true
    },
    closeChangeRoute: function () {
      this.showChangeRoute = false
    },
    openMap: function () {
      this.$emit('openMap')
    }
  },
  computed: {
    ...mapGetters({
      departure: 'destinations/getDepatureStation',
      arrival: 'destinations/getArrivalStation',
      routes: 'routes/getAll',
      destinations: 'destinations/getAll',
      sections: 'tickets/getAll',
    }),
    modals: function () {
      return {
        'departure' : {
          callback: (name) => this.setDeparture(name),
          component: Departure
        },
        'arrival' : {
          callback: (name) => this.setArrival(name),
          component: Arrival
        },
        'visit' : {
          callback: (destination, time) => this.timeUpdate(destination, time),
          component: Visit
        },
        'place' : {
          callback: (index, time, place) => this.addPlace(index, time, place),
          component: NewPlace
        },
        'favorite' : {
          callback: (index, time, place) => this.addPlace(index, time, place),
          component: NewPlaceFavorite
        },
        'datetime' : {
          callback: (destination, arrivalTime) => this.datetimeUpdate(destination, arrivalTime),
          component: Datetime
        },
      }
    },
    isError: function () {
      return this.$store.getters['routes/isError']
    },
    departureTime: function () {
      return this.routes[0] && this.routes[0].departureTime
    },
    arrivalTime: function () {
      return this.routes.slice(-1)[0] && this.routes.slice(-1)[0].arrivalTime
    }
  },
  watch: {
    isError: function (val)  {
      const m = this.$t('tour_not_found_route_message')
      if (val) this.$alert({ message: m })
    }
  }
}
</script>
